<template>
  <!---全体を囲む--->
  <div class="content-wrapper" :class="`sanrio--${sanrioType}`">
    <TemplatePass v-if="isReadyToDraw" />

    <!-- 描画ローディング -->
    <DialogInitialLoading v-else />

    <DialogHasExchangeableCoupon ref="DialogHasExchangeableCoupon" />
  </div>
  <!---全体を囲む--->
</template>

<script>
import TemplatePass from "@/views/Templates/MyTickets/TemplatePass.vue";

import { onMounted, computed, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

import passService from "@/services/pass";

import API from "@/API";

import mfittService from "@/services/MFITT";
import nativeHandlerService from "@/services/nativeHandler";
import { buildShareholderSurveyRoute } from "@/services/survey";

export default {
  components: {
    TemplatePass: TemplatePass,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const sanrioType = ref(null);
    const isReadyToDraw = ref(false);

    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);
    const book = computed(() => store.getters["ticketing/book"]);
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const masterPass = computed(() => store.getters["ticketing/masterPass"]);
    const myCoupons = computed(() => store.getters["MFITT/myCoupons"]);

    const DialogHasExchangeableCoupon = ref(null);

    const openDialogIfHasExchangeableCoupon = () => {
      if (
        mfittService.checkHasExchangeableCouponsWithBook(
          myCoupons.value,
          book.value.id
        )
      ) {
        DialogHasExchangeableCoupon.value.openDialog();
      }
    };

    onMounted(async () => {
      try {
        nativeHandlerService.ncAppVersion();

        await Promise.all([
          API.getMyticketDetail(route.params.book_group_id),
          API.getMyCoupons(),
        ]);

        if (
          bookGroup.value.master_survey_id > 0 &&
          bookGroup.value.is_answered === false
        ) {
          redirectToShareholderSurvey();
          return;
        }

        const usePassIndex = passService.getUsePassIndex(
          route.params.pass_id,
          bookGroup.value
        );

        // 該当パスをstoreへ格納
        store.commit(
          "ticketing/setPass",
          bookGroup.value.books[0].passes[usePassIndex]
        );
        store.commit(
          "ticketing/setMasterPass",
          bookGroup.value.books[0].passes[usePassIndex]._master_pass
        );

        setSanrioStyleClass();

        openDialogIfHasExchangeableCoupon();

        isReadyToDraw.value = true;
      } catch (err) {
        nativeHandlerService.ncSendTicketingError(
          "Pass onMounted()",
          JSON.stringify(err)
        );
      }
    });

    const redirectToShareholderSurvey = () => {
      router.replace(
        buildShareholderSurveyRoute(bookGroup.value, masterBook.value)
      );
    };

    const setSanrioStyleClass = () => {
      // サンリオ(2022.4まで)の場合は平日・休日に合わせてCSSを使い分け
      if (masterPass.value.content.master_pass_id == 290) {
        sanrioType.value = "weekdays";
      } else if (masterPass.value.content.master_pass_id == 309) {
        sanrioType.value = "weekend";
      }
    };

    return {
      isReadyToDraw,
      sanrioType,
      DialogHasExchangeableCoupon,
    };
  },
};
</script>

<style lang="scss">
.content-wrapper {
  padding-bottom: var(--sticky-height--withoutCheckbox);
}

.sanrio--weekdays .header {
  background: #6a95fa !important;
  color: white;
}

.sanrio--weekdays .footer.before-use .btn-primary {
  background: #6a95fa !important;
  color: white !important;
}

.sanrio--weekdays .footer.before-use .start_button {
  background: #6a95fa !important;
  color: white !important;
}

.sanrio--weekend .header {
  background: #ff7778 !important;
  color: white;
}

.sanrio--weekend .footer.before-use .btn-primary {
  background: #ff7778 !important;
  color: white !important;
}

.sanrio--weekend .footer.before-use .start_button {
  background: #ff7778 !important;
  color: white !important;
}
</style>
